export enum RentalColumns {
    SummaryItemType = 'summaryItemType',
    OutstandingAmount = 'outstandingAmount',
    OutstandingNumber = 'outstandingNumber',
    BfiRepaysAmount = 'bfiRepaysAmount',
    BfiRepaysNumber = 'bfiRepaysNumber',
}
